import { Locale } from './types';

export function localize(key: string, locale: Locale): string {
  const langJson = localStorage.getItem('lang');
  if (!langJson) return 'no_lang_found_in_local_storage';
  const lang = JSON.parse(langJson);
  return lang[locale][key] || key;
}
